/* ACC_BN_LP_103 — Section 05: How It Works — Swiper init/destroy */
(function () {
  'use strict';

  const BREAKPOINT = 1200;
  let swiperInstance = null;

  function initSwiper() {
    if (window.innerWidth >= BREAKPOINT) return;
    if (swiperInstance) return; // already running

    const el = document.querySelector('.acc103-05__swiper');
    if (!el) return;

    // Dynamically import Swiper ESM
    import('https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.mjs')
      .then(function (mod) {
        const Swiper = mod.default || mod.Swiper;
        swiperInstance = new Swiper(el, {
          slidesPerView: 1.3,
          centeredSlides: true,
          spaceBetween: 12,
          loop: false,
          initialSlide: 0,
          pagination: {
            el: el.querySelector('.swiper-pagination'),
            clickable: true
          },
          breakpoints: {
            480: {
              slidesPerView: 1.2,
              spaceBetween: 16
            },
            768: {
              slidesPerView: 2,
              centeredSlides: false,
              spaceBetween: 20
            }
          },
          a11y: {
            prevSlideMessage: 'Previous step',
            nextSlideMessage: 'Next step'
          }
        });
        // loop + centeredSlides can land the initial slide off the first item — force it
        swiperInstance.slideToLoop(0, 0);
      })
      .catch(function (err) {
        console.warn('ACC103-05: Swiper load failed', err);
      });
  }

  function destroySwiper() {
    if (!swiperInstance) return;
    swiperInstance.destroy(true, true);
    swiperInstance = null;
  }

  function onResize() {
    if (window.innerWidth >= BREAKPOINT) {
      destroySwiper();
    } else {
      initSwiper();
    }
  }

  // Debounced resize
  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(onResize, 150);
  });

  // Initial call
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwiper);
  } else {
    initSwiper();
  }
})();
